// extracted by mini-css-extract-plugin
export var infoSection = "_p-1";
export var infoSectionContainer = "_p-0";
export var infoSectionTitleRow = "_p-2";
export var multiLineInfo = "_p-4";
export var strong = "_p-3";